import { render } from "./JobDetails.vue?vue&type=template&id=ccebcbb4&scoped=true"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"

import "./JobDetails.vue?vue&type=style&index=0&id=ccebcbb4&scoped=true&lang=css"

import exportComponent from "/Users/jonathanhuttmann/Downloads/adancareers/adancareers_vue/myomek/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccebcbb4"]])

export default __exports__